import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {SupplierEntityModel} from "../supplier-entity.model";
import {Config} from "../../../config";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "supplier-edit-page",
    templateUrl: "./supplier-edit-page.component.html",
    providers: [provideEntityModel(SupplierEntityModel)]
})
export class SupplierEditPageComponent extends AbstractEditPage {
    Config = Config;

    constructor(public model: SupplierEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
